// if (!customElements.get('media-gallery')) {
//   customElements.define(
//     'media-gallery',
//     class MediaGallery extends HTMLElement {
//       constructor() {
//         super();
//         this.elements = {
//           liveRegion: this.querySelector('[id^="GalleryStatus"]'),
//           viewer: this.querySelector('[id^="GalleryViewer"]'),
//           thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
//         };
//         this.mql = window.matchMedia('(min-width: 750px)');
//         if (!this.elements.thumbnails) return;

//         this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
//         this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
//           mediaToSwitch
//             .querySelector('button')
//             .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
//         });
//         if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
//       }

//       // onSlideChanged(event) {
//       //   const thumbnail = this.elements.thumbnails.querySelector(
//       //     `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
//       //   );
//       //   this.setActiveThumbnail(thumbnail);
//       // }
//       onSlideChanged(event) {
//         const currentMediaId = event.detail.currentElement.dataset.mediaId;

//         const thumbnail = this.elements.thumbnails?.querySelector(
//           `[data-target="${currentMediaId}"]`
//         );

//         if (thumbnail) {
//           this.setActiveThumbnail(thumbnail);
//         }

//         const currentIndex = Array.from(
//           this.elements.viewer.querySelectorAll('[data-media-id]')
//         ).findIndex((item) => item.dataset.mediaId === currentMediaId);

//         const counter = this.elements.viewer.querySelector('.slider-counter--current');
//         if (counter && currentIndex > -1) {
//           counter.textContent = currentIndex + 1;
//         }
//       }
//       setActiveMedia(mediaId, prepend) {
//         const activeMedia =
//           this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
//           this.elements.viewer.querySelector('[data-media-id]');
//         if (!activeMedia) {
//           return;
//         }
//         this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
//           element.classList.remove('is-active');
//         });
//         activeMedia?.classList?.add('is-active');

//         if (prepend) {
//           activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

//           if (this.elements.thumbnails) {
//             const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//             activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
//           }

//           if (this.elements.viewer.slider) this.elements.viewer.resetPages();
//         }

//         this.preventStickyHeader();
//         window.setTimeout(() => {
//           if (!this.mql.matches || this.elements.thumbnails) {
//           activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
//           }
//           const activeMediaRect = activeMedia.getBoundingClientRect();
//           // Don't scroll if the image is already in view
//           if (activeMediaRect.top > -0.5) return;
//           const top = activeMediaRect.top + window.scrollY;
//           window.scrollTo({ top: top, behavior: 'smooth' });
//         });
//         this.playActiveMedia(activeMedia);

//         if (!this.elements.thumbnails) return;
//         const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
//           this.setActiveThumbnail(activeThumbnail);
//           this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
//         }

//       setActiveThumbnail(thumbnail) {
//         if (!this.elements.thumbnails || !thumbnail) return;

//         this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
//         thumbnail.querySelector('button').setAttribute('aria-current', true);

//         if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

//         this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
//       }

//       announceLiveRegion(activeItem, position) {
//         const image = activeItem.querySelector('.product__modal-opener--image img');
//         if (!image) return;

//         image.onload = () => {
//           this.elements.liveRegion.setAttribute('aria-hidden', false);
//           this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);

//           setTimeout(() => {
//             this.elements.liveRegion.setAttribute('aria-hidden', true);
//           }, 2000);
//         };

//         image.src = image.src;
//       }

//       playActiveMedia(activeItem) {
//         window.pauseAllMedia();

//         const deferredMedia = activeItem.querySelector('.deferred-media');
//         if (deferredMedia) deferredMedia.loadContent(false);
//       }

//       preventStickyHeader() {
//         this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
//         if (!this.stickyHeader) return;

//         this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
//       }

//       removeListSemantic() {
//         if (!this.elements.viewer.slider) return;

//         this.elements.viewer.slider.setAttribute('role', 'presentation');
//         this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
//       }
//     }
//   );
// }

if (!customElements.get('media-gallery')) {
    customElements.define(
      'media-gallery',
      class MediaGallery extends HTMLElement {
        constructor() {
          super();
          this.elements = {
            liveRegion: this.querySelector('[id^="GalleryStatus"]'),
            viewer: this.querySelector('[id^="GalleryViewer"]'),
            thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          };
          this.mql = window.matchMedia('(min-width: 750px)');
          if (!this.elements.thumbnails) return;

          this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
          this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
            mediaToSwitch
              .querySelector('button')
              .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          });

          if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
            this.removeListSemantic();
          }

          // Set up desktop prev/next buttons.
          // On desktop the viewer list is a CSS grid (not a scroll container), so the
          // default SliderComponent scroll-based navigation does nothing. We intercept
          // the button clicks here and drive navigation through setActiveMedia instead.
          this.setupDesktopSliderButtons();
        }

        // ─── Desktop prev / next ──────────────────────────────────────────────────

        setupDesktopSliderButtons() {
          const prevBtn = this.elements.viewer.querySelector('.slider-button--prev');
          const nextBtn = this.elements.viewer.querySelector('.slider-button--next');
          if (!prevBtn || !nextBtn) return;

          prevBtn.addEventListener('click', (e) => {
          if (!this.mql.matches) return;  // ← mobile: do nothing, let SliderComponent handle it
            e.stopImmediatePropagation();
            this.navigateDesktop(-1);
          });             

          nextBtn.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            this.navigateDesktop(1);
          });
        }

        navigateDesktop(direction) {
          const slides = Array.from(this.elements.viewer.querySelectorAll('li[data-media-id]'));
          if (!slides.length) return;

          const currentIndex = slides.findIndex((el) => el.classList.contains('is-active'));
          const activeIndex = currentIndex === -1 ? 0 : currentIndex;
          const nextIndex = Math.max(0, Math.min(slides.length - 1, activeIndex + direction));

          if (nextIndex === activeIndex) return;

          // Flag so onSlideChanged (fired by mobile scroll) doesn't fight us on desktop
          this._desktopNavigating = true;

          const nextSlide = slides[nextIndex];
          const nextMediaId = nextSlide.dataset.mediaId;

          // Manually swap is-active directly here so it's guaranteed correct
          slides.forEach((el) => el.classList.remove('is-active'));
          nextSlide.classList.add('is-active');

          // Sync the thumbnail strip
          const activeThumbnail = this.elements.thumbnails
            ? this.elements.thumbnails.querySelector(`[data-target="${nextMediaId}"]`)
            : null;
          if (activeThumbnail) {
            this.setActiveThumbnail(activeThumbnail);
          }

          // Keep the counter in sync
          const counter = this.elements.viewer.querySelector('.slider-counter--current');
          if (counter) counter.textContent = nextIndex + 1;

          // Play media (video/model support)
          this.playActiveMedia(nextSlide);
          this.preventStickyHeader();

          this._desktopNavigating = false;
        }

        // ─── Slide changed (mobile scroll-based) ─────────────────────────────────

        onSlideChanged(event) {
          if (this._desktopNavigating) return;
          const thumbnail = this.elements.thumbnails.querySelector(
            `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
          );
          this.setActiveThumbnail(thumbnail);
        }

        // ─── Core media activation ────────────────────────────────────────────────

        setActiveMedia(mediaId, prepend) {
          const activeMedia = this.elements.viewer.querySelector(`li[data-media-id="${mediaId}"]`);
          if (!activeMedia) return;

          this.elements.viewer.querySelectorAll('li[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });
          activeMedia.classList.add('is-active');

          if (prepend) {
            activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

            if (this.elements.thumbnails) {
              const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
              activeThumbnail.parentElement.firstChild !== activeThumbnail &&
                activeThumbnail.parentElement.prepend(activeThumbnail);
            }

            if (this.elements.viewer.slider) this.elements.viewer.resetPages();
          }

          this.preventStickyHeader();
          window.setTimeout(() => {
            if (!this.mql.matches || this.elements.thumbnails) {
              activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
            }
            const activeMediaRect = activeMedia.getBoundingClientRect();
            // Don't scroll if the image is already in view
            if (activeMediaRect.top > -0.5) return;
            const top = activeMediaRect.top + window.scrollY;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
          this.playActiveMedia(activeMedia);

          if (!this.elements.thumbnails) return;
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
          this.setActiveThumbnail(activeThumbnail);
          if (activeThumbnail) this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        setActiveThumbnail(thumbnail) {
          if (!this.elements.thumbnails || !thumbnail) return;

          this.elements.thumbnails
            .querySelectorAll('button')
            .forEach((element) => element.removeAttribute('aria-current'));
          thumbnail.querySelector('button').setAttribute('aria-current', true);
          if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }

        // ─── Helpers ──────────────────────────────────────────────────────────────

        announceLiveRegion(activeItem, position) {
          const image = activeItem.querySelector('.product__modal-opener--image img');
          if (!image) return;
          image.onload = () => {
            this.elements.liveRegion.setAttribute('aria-hidden', false);
            this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
            setTimeout(() => {
              this.elements.liveRegion.setAttribute('aria-hidden', true);
            }, 2000);
          };
          image.src = image.src;
        }

        playActiveMedia(activeItem) {
          window.pauseAllMedia();
          const deferredMedia = activeItem.querySelector('.deferred-media');
          if (deferredMedia) deferredMedia.loadContent(false);
        }

        preventStickyHeader() {
          this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
          if (!this.stickyHeader) return;
          this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
        }

        removeListSemantic() {
          if (!this.elements.viewer.slider) return;
          this.elements.viewer.slider.setAttribute('role', 'presentation');
          this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
        }
      }
    );
  }